@if (state === 'loading') {
  <app-spinner></app-spinner>
}
@if (state === 'offline') {
  <tyt-offline message="You need an Internet connection to manage your privacy controls"></tyt-offline>
}
@if (state === 'ready') {
  @if (user) {
    <mat-tab-group mat-stretch-tabs="false">
      <mat-tab label="My Profile" >
        <div class="profile-visibility">
          <div class="header">
            <h1>Profile Visibility</h1>
            <h3>
              @if (!tytnEnabled) {
                Select which parts of your profile are publically visible.
              } @else {
                Select which parts of your profile are public,
                viewable by your followers only, or hidden.
              }
              Our commitment to your privacy is paramount. View our <a routerLink="/privacy">Privacy Policy</a> for
              more information.
            </h3>
          </div>
          <div class="options">
            @for (control of profileControls; track control) {
              @if (!control.visible || control.visible()) {
                <div>
                  <div class="title">{{control.title}}</div>
                  @if (control.subtitle) {
                    <div class="subtitle">{{control.subtitle}}</div>
                  }
                  <mat-button-toggle-group [disabled]="loadingUpdate || currentUsername === 'home'" [value]="privacySettings[control.profileProperty]">
                    @for (option of visibilityOptions; track option) {
                      @if (!option.visible || option.visible()) {
                        <mat-button-toggle
                          (change)="setProfileVisibilityPropertyValue(control.profileProperty, $event)"
                        [value]="option.value">{{option.label}}</mat-button-toggle>
                      }
                    }
                  </mat-button-toggle-group>
                </div>
              }
            }
          </div>
        </div>
      </mat-tab>
      <mat-tab label="My Data">
        @if (!showDeleteData) {
          <div class="privacy-controls-container">
            <p class="header">You have choices regarding the information we collect and how it's used</p>
            <p class="description">This section describes key controls for managing your privacy across our services.
              <!-- You can also visit the Privacy Checkup,
              which provides an opportunity to review and adjust important privacy settings.
              --> In addition to these options, we also offer
              specific privacy settings in our products — you can learn more in our <a routerLink="/privacy">Privacy
            Policy.</a>
          </p>
          <div class="content">
            <div class="content-image">
              <img src="/assets/privacy/silhouette_shield.svg">
            </div>
            <div class="content-main">
              <p class="content-header">Account Personalization</p>
              <p class="content-description">
                You may wish to review the profile information you've provided in case you wish to remove or change it.
                We do not retain profile/personalization data which you have removed.
              </p>
              <ul>
                <li>@if (user) {
                  <a routerLink="/@{{user.username}}">View, Change, or Delete Profile Data</a>
                }</li>
                <li><a routerLink="/settings/content">View, Change, or Delete Personalization Data</a></li>
                <li><a routerLink="/settings/newsletters">View, Change or Delete Communication Preferences</a></li>
              </ul>
            </div>
          </div>
          @if (downloadDataEnabled) {
            <div class="content">
              <div class="content-image">
                <img src="/assets/privacy/silhouette_shield.svg">
              </div>
              <div class="">
                <p class="content-header">Download My Data</p>
                <p class="content-description">
                  You have the option to download a ZIP file of the data we collect. The ZIP file will contain multiple CSV
                  files that can be imported to Microsoft Excel or Google Sheets, and will contain information such as your
                  email address, name, membership transaction history, gift purchases and redemptions, video consumption data,
                  and affiliate sales - in short, all the information you’ve provided for your account, and all the data we’ve
                  collected about your account up to the time of your download.
                </p>
                @if (dataDownloadErrorMessage) {
                  <div class="alert alert-danger">
                    {{dataDownloadErrorMessage}}
                  </div>
                }
                @if (downloadDataSuccess) {
                  <div class="alert alert-success">
                    We are processing your data download request. You should receive an email with the link to download your
                    data shortly.
                  </div>
                }
                @if (downloadDataStarted) {
                  <app-spinner></app-spinner>
                }
                <div class="content-buttons">
                  @if (!downloadDataSuccess && !downloadDataStarted) {
                    <button mat-raised-button (click)="downloadData()">Download My
                    Data</button>
                  }
                </div>
              </div>
            </div>
          }
          <div class="content">
            <div class="content-image">
              <img src="/assets/privacy/silhouette_shield.svg">
            </div>
            <div class="">
              <p class="content-header">Delete My Data</p>
              <p class="content-description">
                If you wish to close your TYT account and have us delete your information you
                can do so below. Note that you must first cancel any recurring TYT memberships you may have before you can
                use
                this option.
              </p>
              <div class="content-buttons">
                <a mat-raised-button routerLink="/settings/delete-data">Delete all data and close account</a>
              </div>
            </div>
          </div>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
}
}